import "./App.css";
import 'animate.css';
import {useState, useEffect} from "react";
import {Routes, Route} from "react-router-dom";
import Home from './Home';
import SingleplayerSetup from "./SingleplayerComponents/SingleplayerSetup";
import SingleplayerGame from "./SingleplayerComponents/SingleplayerGame";


export default function App() {


    const [gameSettings, setGameSettings] = useState({
        timeLimit: 10, scoreLimit: 50, checkWordList: true, autoFillFirstLetter: false,
    })


    useEffect(() => {
        console.log(gameSettings)
    }, [gameSettings])


    function handleGameSettingChange(setting) {

        if (setting.hasOwnProperty('timeLimit')) setGameSettings(gameSettings => ({
            ...gameSettings, timeLimit: setting.timeLimit
        }))

        if (setting.hasOwnProperty('scoreLimit')) setGameSettings(gameSettings => ({
            ...gameSettings, scoreLimit: setting.scoreLimit
        }))

        if (setting.hasOwnProperty('checkWordList')) setGameSettings(gameSettings => ({
            ...gameSettings, checkWordList: setting.checkWordList
        }))

        if (setting.hasOwnProperty('autoFillFirstLetter')) setGameSettings(gameSettings => ({
            ...gameSettings, autoFillFirstLetter: setting.autoFillFirstLetter
        }))
    }

    return (<>
            <Routes>
                <Route path="/" element={<Home/>}/>

                {/* Singleplayer routes */}
                <Route path="/singleplayer/setup" element={<SingleplayerSetup gameSettings={gameSettings}
                                                                              onGameSettingChange={handleGameSettingChange}/>}/>
                <Route path="/singleplayer/gameplay" element={<SingleplayerGame gameSettings={gameSettings}/>}/>

            </Routes>
        </>


    );
}
